import { BriefingBlockTypeEnum } from '../enums/briefing-block-type.enum';

/**
 * A mapping of blockTypes to its properties and their related generalStyle properties
 */
export const briefingBlockToGeneralStyle = new Map<BriefingBlockTypeEnum, Map<string, string>>(
    [
        [
            BriefingBlockTypeEnum.DATE,
            new Map<string, string>(
                [
                    ['styles.styleState', 'date.styleState'],
                    ['styles.displayStyleState', 'date.displayStyleState'],
                    ['styles.backgroundColor', 'date.backgroundColor'],
                    ['styles.font.bold', 'date.font.bold'],
                    ['styles.font.italics', 'date.font.italics'],
                    ['styles.font.underlined', 'date.font.underlined'],
                    ['styles.font.color', 'date.font.color'],
                    ['styles.font.fontFamily', 'date.font.fontFamily'],
                    ['styles.font.fontSize', 'date.font.fontSize'],
                    ['styles.dateFormat', 'date.dateFormat'],
                    ['styles.showTimeZone', 'date.showTimeZone'],
                    ['styles.timezone', 'date.timezone'],
                    ['styles.showTime', 'date.showTime'],
                    ['styles.padding', 'date.padding'],
                    ['styles.locale', 'date.locale']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.TEXT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'text.styleState'],
                    ['styles.displayStyleState', 'text.displayStyleState'],
                    ['styles.color', 'text.color'],
                    ['styles.backgroundColor', 'text.backgroundColor'],
                    ['styles.fontFamily', 'text.fontFamily'],
                    ['styles.fontSize', 'text.fontSize'],
                    ['styles.italics', 'text.italics'],
                    ['styles.underlined', 'text.underlined'],
                    ['styles.bold', 'text.bold'],
                    ['styles.alignment', 'text.alignment'],
                    ['styles.padding', 'text.padding']

                ]
            )
        ],
        [
            BriefingBlockTypeEnum.TITLE,
            new Map<string, string>(
                [
                    ['styles.styleState', 'title.styleState'],
                    ['styles.displayStyleState', 'title.displayStyleState'],
                    ['styles.color', 'title.color'],
                    ['styles.fontFamily', 'title.fontFamily'],
                    ['styles.fontSize', 'title.fontSize'],
                    ['styles.italics', 'title.italics'],
                    ['styles.underlined', 'title.underlined'],
                    ['styles.bold', 'title.bold'],
                    ['styles.alignment', 'title.alignment'],
                    ['styles.backgroundColor', 'title.backgroundColor'],
                    ['styles.padding', 'title.padding'],
                    ['styles.headingTwo.color', 'title.headingTwo.color'],
                    ['styles.headingTwo.fontFamily', 'title.headingTwo.fontFamily'],
                    ['styles.headingTwo.fontSize', 'title.headingTwo.fontSize'],
                    ['styles.headingTwo.bold', 'title.headingTwo.bold'],
                    ['styles.headingTwo.italics', 'title.headingTwo.italics'],
                    ['styles.headingTwo.underlined', 'title.headingTwo.underlined'],
                    ['styles.headingTwo.alignment', 'title.headingTwo.alignment'],
                    ['styles.headingTwo.backgroundColor', 'title.headingTwo.backgroundColor'],
                    ['styles.beadingTwo.padding', 'title.headingTwo.padding'],
                    ['styles.headingThree.color', 'title.headingThree.color'],
                    ['styles.headingThree.fontFamily', 'title.headingThree.fontFamily'],
                    ['styles.headingThree.fontSize', 'title.headingThree.fontSize'],
                    ['styles.headingThree.bold', 'title.headingThree.bold'],
                    ['styles.headingThree.italics', 'title.headingThree.italics'],
                    ['styles.headingThree.underlined', 'title.headingThree.underlined'],
                    ['styles.headingThree.alignment', 'title.headingThree.alignment'],
                    ['styles.headingThree.backgroundColor', 'title.headingThree.backgroundColor'],
                    ['styles.beadingThree.padding', 'title.headingTwo.padding']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.IMAGE,
            new Map<string, string>(
                [
                    ['styles.styleState', 'image.styleState'],
                    ['styles.displayStyleState', 'image.displayStyleState'],
                    ['styles.color', 'image.color'],
                    ['styles.backgroundColor', 'image.backgroundColor'],
                    ['styles.fontFamily', 'image.fontFamily'],
                    ['styles.fontSize', 'image.fontSize'],
                    ['styles.italics', 'image.italics'],
                    ['styles.underlined', 'image.underlined'],
                    ['styles.bold', 'image.bold'],
                    ['styles.alignment', 'image.alignment'],
                    ['styles.imageAlignment', 'image.imageAlignment'],
                    ['styles.width', 'image.width'],
                    ['styles.padding', 'image.padding'],
                    ['styles.cornerRadius', 'image.cornerRadius']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.CURATED_MENTION_LIST,
            new Map<string, string>(
                [
                    ['styles.styleState', 'mention.styleState'],
                    ['styles.displayStyleState', 'mention.displayStyleState'],
                    ['styles.mentionContent', 'mention.mentionContent'],
                    ['styles.showInsights', 'mention.showInsights'],
                    ['styles.displayInsightsName', 'mention.displayInsightsName'],
                    ['styles.insightsNameDisplay', 'mention.insightsNameDisplay'],
                    ['styles.customInsightsName', 'mention.customInsightsName'],
                    ['styles.mentionInsightsLinkLabel', 'mention.mentionInsightsLinkLabel'],
                    ['styles.metadataTypes', 'mention.metadataTypes'],
                    ['styles.metadataOrder', 'mention.metadataOrder'],
                    ['styles.mediaType', 'mention.mediaType'],
                    ['styles.outletIcon', 'mention.outletIcon'],
                    ['styles.image', 'mention.image'],
                    ['styles.imageSize', 'mention.imageSize'],
                    ['styles.notes', 'mention.notes'],
                    ['styles.heading.color', 'mention.heading.color'],
                    ['styles.heading.fontFamily', 'mention.heading.fontFamily'],
                    ['styles.heading.fontSize', 'mention.heading.fontSize'],
                    ['styles.heading.bold', 'mention.heading.bold'],
                    ['styles.heading.italics', 'mention.heading.italics'],
                    ['styles.heading.underlined', 'mention.heading.underlined'],
                    ['styles.heading.alignment', 'mention.heading.alignment'],
                    ['styles.sectionHeading.color', 'mention.sectionHeading.color'],
                    ['styles.sectionHeading.fontFamily', 'mention.sectionHeading.fontFamily'],
                    ['styles.sectionHeading.fontSize', 'mention.sectionHeading.fontSize'],
                    ['styles.sectionHeading.bold', 'mention.sectionHeading.bold'],
                    ['styles.sectionHeading.italics', 'mention.sectionHeading.italics'],
                    ['styles.sectionHeading.underlined', 'mention.sectionHeading.underlined'],
                    ['styles.sectionHeading.alignment', 'mention.sectionHeading.alignment'],
                    ['styles.notesFont.color', 'mention.notesFont.color'],
                    ['styles.notesFont.fontFamily', 'mention.notesFont.fontFamily'],
                    ['styles.notesFont.fontSize', 'mention.notesFont.fontSize'],
                    ['styles.notesFont.bold', 'mention.notesFont.bold'],
                    ['styles.notesFont.italics', 'mention.notesFont.italics'],
                    ['styles.notesFont.underlined', 'mention.notesFont.underlined'],
                    ['styles.notesFont.alignment', 'mention.notesFont.alignment'],
                    ['styles.snippetFont.color', 'mention.snippetFont.color'],
                    ['styles.snippetFont.fontFamily', 'mention.snippetFont.fontFamily'],
                    ['styles.snippetFont.fontSize', 'mention.snippetFont.fontSize'],
                    ['styles.snippetFont.bold', 'mention.snippetFont.bold'],
                    ['styles.snippetFont.italics', 'mention.snippetFont.italics'],
                    ['styles.snippetFont.underlined', 'mention.snippetFont.underlined'],
                    ['styles.snippetFont.alignment', 'mention.snippetFont.alignment'],
                    ['styles.insightsFont.color', 'mention.insightsFont.color'],
                    ['styles.insightsFont.fontFamily', 'mention.insightsFont.fontFamily'],
                    ['styles.insightsFont.fontSize', 'mention.insightsFont.fontSize'],
                    ['styles.insightsFont.bold', 'mention.insightsFont.bold'],
                    ['styles.insightsFont.italics', 'mention.insightsFont.italics'],
                    ['styles.insightsFont.underlined', 'mention.insightsFont.underlined'],
                    ['styles.insightsFont.alignment', 'mention.insightsFont.alignment'],
                    ['styles.mentionInsightsLinkFont.color', 'mention.mentionInsightsLinkFont.color'],
                    ['styles.mentionInsightsLinkFont.fontFamily', 'mention.mentionInsightsLinkFont.fontFamily'],
                    ['styles.mentionInsightsLinkFont.fontSize', 'mention.mentionInsightsLinkFont.fontSize'],
                    ['styles.mentionInsightsLinkFont.bold', 'mention.mentionInsightsLinkFont.bold'],
                    ['styles.mentionInsightsLinkFont.italics', 'mention.mentionInsightsLinkFont.italics'],
                    ['styles.mentionInsightsLinkFont.underlined', 'mention.mentionInsightsLinkFont.underlined'],
                    ['styles.metadataFont.color', 'mention.metadataFont.color'],
                    ['styles.metadataFont.fontFamily', 'mention.metadataFont.fontFamily'],
                    ['styles.metadataFont.bold', 'mention.metadataFont.bold'],
                    ['styles.metadataFont.italics', 'mention.metadataFont.italics'],
                    ['styles.metadataFont.underlined', 'mention.metadataFont.underlined'],
                    ['styles.preferredCurrency', 'mention.preferredCurrency'],
                    ['styles.timezone', 'mention.timezone'],
                    ['styles.dateFormat', 'mention.dateFormat'],
                    ['styles.showSectionHeading', 'mention.showSectionHeading'],
                    ['styles.accentColor', 'accentColor'],
                    ['styles.padding', 'mention.padding'],
                    ['styles.cardHeight', 'mention.cardHeight'],
                    ['styles.locale', 'mention.locale']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST,
            new Map<string, string>(
                [
                    ['styles.styleState', 'mention.styleState'],
                    ['styles.displayStyleState', 'mention.displayStyleState'],
                    ['styles.mentionContent', 'mention.mentionContent'],
                    ['styles.showInsights', 'mention.showInsights'],
                    ['styles.displayInsightsName', 'mention.displayInsightsName'],
                    ['styles.insightsNameDisplay', 'mention.insightsNameDisplay'],
                    ['styles.customInsightsName', 'mention.customInsightsName'],
                    ['styles.mentionInsightsLinkLabel', 'mention.mentionInsightsLinkLabel'],
                    ['styles.metadataTypes', 'mention.metadataTypes'],
                    ['styles.metadataOrder', 'mention.metadataOrder'],
                    ['styles.mediaType', 'mention.mediaType'],
                    ['styles.outletIcon', 'mention.outletIcon'],
                    ['styles.image', 'mention.image'],
                    ['styles.imageSize', 'mention.imageSize'],
                    ['styles.notes', 'mention.notes'],
                    ['styles.heading.color', 'mention.heading.color'],
                    ['styles.heading.fontFamily', 'mention.heading.fontFamily'],
                    ['styles.heading.fontSize', 'mention.heading.fontSize'],
                    ['styles.heading.bold', 'mention.heading.bold'],
                    ['styles.heading.italics', 'mention.heading.italics'],
                    ['styles.heading.underlined', 'mention.heading.underlined'],
                    ['styles.heading.alignment', 'mention.heading.alignment'],
                    ['styles.sectionHeading.color', 'mention.sectionHeading.color'],
                    ['styles.sectionHeading.fontFamily', 'mention.sectionHeading.fontFamily'],
                    ['styles.sectionHeading.fontSize', 'mention.sectionHeading.fontSize'],
                    ['styles.sectionHeading.bold', 'mention.sectionHeading.bold'],
                    ['styles.sectionHeading.italics', 'mention.sectionHeading.italics'],
                    ['styles.sectionHeading.underlined', 'mention.sectionHeading.underlined'],
                    ['styles.sectionHeading.alignment', 'mention.sectionHeading.alignment'],
                    ['styles.notesFont.color', 'mention.notesFont.color'],
                    ['styles.notesFont.fontFamily', 'mention.notesFont.fontFamily'],
                    ['styles.notesFont.fontSize', 'mention.notesFont.fontSize'],
                    ['styles.notesFont.bold', 'mention.notesFont.bold'],
                    ['styles.notesFont.italics', 'mention.notesFont.italics'],
                    ['styles.notesFont.underlined', 'mention.notesFont.underlined'],
                    ['styles.notesFont.alignment', 'mention.notesFont.alignment'],
                    ['styles.snippetFont.color', 'mention.snippetFont.color'],
                    ['styles.snippetFont.fontFamily', 'mention.snippetFont.fontFamily'],
                    ['styles.snippetFont.fontSize', 'mention.snippetFont.fontSize'],
                    ['styles.snippetFont.bold', 'mention.snippetFont.bold'],
                    ['styles.snippetFont.italics', 'mention.snippetFont.italics'],
                    ['styles.snippetFont.underlined', 'mention.snippetFont.underlined'],
                    ['styles.snippetFont.alignment', 'mention.snippetFont.alignment'],
                    ['styles.insightsFont.color', 'mention.insightsFont.color'],
                    ['styles.insightsFont.fontFamily', 'mention.insightsFont.fontFamily'],
                    ['styles.insightsFont.fontSize', 'mention.insightsFont.fontSize'],
                    ['styles.insightsFont.bold', 'mention.insightsFont.bold'],
                    ['styles.insightsFont.italics', 'mention.insightsFont.italics'],
                    ['styles.insightsFont.underlined', 'mention.insightsFont.underlined'],
                    ['styles.insightsFont.alignment', 'mention.insightsFont.alignment'],
                    ['styles.mentionInsightsLinkFont.color', 'mention.mentionInsightsLinkFont.color'],
                    ['styles.mentionInsightsLinkFont.fontFamily', 'mention.mentionInsightsLinkFont.fontFamily'],
                    ['styles.mentionInsightsLinkFont.fontSize', 'mention.mentionInsightsLinkFont.fontSize'],
                    ['styles.mentionInsightsLinkFont.bold', 'mention.mentionInsightsLinkFont.bold'],
                    ['styles.mentionInsightsLinkFont.italics', 'mention.mentionInsightsLinkFont.italics'],
                    ['styles.mentionInsightsLinkFont.underlined', 'mention.mentionInsightsLinkFont.underlined'],
                    ['styles.metadataFont.color', 'mention.metadataFont.color'],
                    ['styles.metadataFont.fontFamily', 'mention.metadataFont.fontFamily'],
                    ['styles.metadataFont.bold', 'mention.metadataFont.bold'],
                    ['styles.metadataFont.italics', 'mention.metadataFont.italics'],
                    ['styles.metadataFont.underlined', 'mention.metadataFont.underlined'],
                    ['styles.preferredCurrency', 'mention.preferredCurrency'],
                    ['styles.timezone', 'mention.timezone'],
                    ['styles.dateFormat', 'mention.dateFormat'],
                    ['styles.showSectionHeading', 'mention.showSectionHeading'],
                    ['styles.accentColor', 'accentColor'],
                    ['styles.padding', 'mention.padding'],
                    ['styles.cardHeight', 'mention.cardHeight'],
                    ['styles.locale', 'mention.locale']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.ALERT_MENTIONS,
            new Map<string, string>(
                [
                    ['styles.styleState', 'mention.styleState'],
                    ['styles.displayStyleState', 'mention.displayStyleState'],
                    ['styles.mentionContent', 'mention.mentionContent'],
                    ['styles.showInsights', 'mention.showInsights'],
                    ['styles.displayInsightsName', 'mention.displayInsightsName'],
                    ['styles.insightsNameDisplay', 'mention.insightsNameDisplay'],
                    ['styles.customInsightsName', 'mention.customInsightsName'],
                    ['styles.mentionInsightsLinkLabel', 'mention.mentionInsightsLinkLabel'],
                    ['styles.metadataTypes', 'mention.metadataTypes'],
                    ['styles.metadataOrder', 'mention.metadataOrder'],
                    ['styles.mediaType', 'mention.mediaType'],
                    ['styles.notes', 'mention.notes'],
                    ['styles.heading.color', 'mention.heading.color'],
                    ['styles.heading.fontFamily', 'mention.heading.fontFamily'],
                    ['styles.heading.fontSize', 'mention.heading.fontSize'],
                    ['styles.heading.bold', 'mention.heading.bold'],
                    ['styles.heading.italics', 'mention.heading.italics'],
                    ['styles.heading.underlined', 'mention.heading.underlined'],
                    ['styles.heading.alignment', 'mention.heading.alignment'],
                    ['styles.sectionHeading.color', 'mention.sectionHeading.color'],
                    ['styles.sectionHeading.fontFamily', 'mention.sectionHeading.fontFamily'],
                    ['styles.sectionHeading.fontSize', 'mention.sectionHeading.fontSize'],
                    ['styles.sectionHeading.bold', 'mention.sectionHeading.bold'],
                    ['styles.sectionHeading.italics', 'mention.sectionHeading.italics'],
                    ['styles.sectionHeading.underlined', 'mention.sectionHeading.underlined'],
                    ['styles.sectionHeading.alignment', 'mention.sectionHeading.alignment'],
                    ['styles.notesFont.color', 'mention.notesFont.color'],
                    ['styles.notesFont.fontFamily', 'mention.notesFont.fontFamily'],
                    ['styles.notesFont.fontSize', 'mention.notesFont.fontSize'],
                    ['styles.notesFont.bold', 'mention.notesFont.bold'],
                    ['styles.notesFont.italics', 'mention.notesFont.italics'],
                    ['styles.notesFont.underlined', 'mention.notesFont.underlined'],
                    ['styles.notesFont.alignment', 'mention.notesFont.alignment'],
                    ['styles.snippetFont.color', 'mention.snippetFont.color'],
                    ['styles.snippetFont.fontFamily', 'mention.snippetFont.fontFamily'],
                    ['styles.snippetFont.fontSize', 'mention.snippetFont.fontSize'],
                    ['styles.snippetFont.bold', 'mention.snippetFont.bold'],
                    ['styles.snippetFont.italics', 'mention.snippetFont.italics'],
                    ['styles.snippetFont.underlined', 'mention.snippetFont.underlined'],
                    ['styles.snippetFont.alignment', 'mention.snippetFont.alignment'],
                    ['styles.insightsFont.color', 'mention.insightsFont.color'],
                    ['styles.insightsFont.fontFamily', 'mention.insightsFont.fontFamily'],
                    ['styles.insightsFont.fontSize', 'mention.insightsFont.fontSize'],
                    ['styles.insightsFont.bold', 'mention.insightsFont.bold'],
                    ['styles.insightsFont.italics', 'mention.insightsFont.italics'],
                    ['styles.insightsFont.underlined', 'mention.insightsFont.underlined'],
                    ['styles.insightsFont.alignment', 'mention.insightsFont.alignment'],
                    ['styles.mentionInsightsLinkFont.color', 'mention.mentionInsightsLinkFont.color'],
                    ['styles.mentionInsightsLinkFont.fontFamily', 'mention.mentionInsightsLinkFont.fontFamily'],
                    ['styles.mentionInsightsLinkFont.fontSize', 'mention.mentionInsightsLinkFont.fontSize'],
                    ['styles.mentionInsightsLinkFont.bold', 'mention.mentionInsightsLinkFont.bold'],
                    ['styles.mentionInsightsLinkFont.italics', 'mention.mentionInsightsLinkFont.italics'],
                    ['styles.mentionInsightsLinkFont.underlined', 'mention.mentionInsightsLinkFont.underlined'],
                    ['styles.metadataFont.color', 'mention.metadataFont.color'],
                    ['styles.metadataFont.fontFamily', 'mention.metadataFont.fontFamily'],
                    ['styles.metadataFont.bold', 'mention.metadataFont.bold'],
                    ['styles.metadataFont.italics', 'mention.metadataFont.italics'],
                    ['styles.metadataFont.underlined', 'mention.metadataFont.underlined'],
                    ['styles.preferredCurrency', 'mention.preferredCurrency'],
                    ['styles.timezone', 'mention.timezone'],
                    ['styles.dateFormat', 'mention.dateFormat']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.TABLE_OF_CONTENT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'tableOfContent.styleState'],
                    ['styles.displayStyleState', 'tableOfContent.displayStyleState'],
                    ['styles.color', 'tableOfContent.color'],
                    ['styles.backgroundColor', 'tableOfContent.backgroundColor'],
                    ['styles.fontFamily', 'tableOfContent.fontFamily'],
                    ['styles.fontSize', 'tableOfContent.fontSize'],
                    ['styles.italics', 'tableOfContent.italics'],
                    ['styles.underlined', 'tableOfContent.underlined'],
                    ['styles.bold', 'tableOfContent.bold'],
                    ['styles.alignment', 'tableOfContent.alignment'],
                    ['styles.padding', 'tableOfContent.padding']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'oneColumnLayout.styleState'],
                    ['styles.displayStyleState', 'oneColumnLayout.displayStyleState'],
                    ['styles.backgroundColor', 'oneColumnLayout.backgroundColor'],
                    ['styles.padding', 'oneColumnLayout.padding'],
                    ['styles.width', 'oneColumnLayout.width'],
                    ['styles.cornerRadius', 'oneColumnLayout.cornerRadius']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'twoColumnLayout.styleState'],
                    ['styles.displayStyleState', 'twoColumnLayout.displayStyleState'],
                    ['styles.displayRatio', 'twoColumnLayout.displayRatio'],
                    ['styles.width', 'twoColumnLayout.width'],
                    ['styles.backgroundColor', 'twoColumnLayout.backgroundColor'],
                    ['styles.verticalAlignment', 'twoColumnLayout.verticalAlignment'],
                    ['styles.padding', 'twoColumnLayout.padding'],
                    ['styles.columnSpacing', 'twoColumnLayout.columnSpacing'],
                    ['styles.cornerRadius', 'twoColumnLayout.cornerRadius']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT,
            new Map<string, string>(
                [
                    ['styles.styleState', 'threeColumnLayout.styleState'],
                    ['styles.displayStyleState', 'threeColumnLayout.displayStyleState'],
                    ['styles.displayRatio', 'threeColumnLayout.displayRatio'],
                    ['styles.width', 'threeColumnLayout.width'],
                    ['styles.backgroundColor', 'threeColumnLayout.backgroundColor'],
                    ['styles.verticalAlignment', 'threeColumnLayout.verticalAlignment'],
                    ['styles.padding', 'threeColumnLayout.padding'],
                    ['styles.columnSpacing', 'threeColumnLayout.columnSpacing'],
                    ['styles.cornerRadius', 'threeColumnLayout.cornerRadius']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.ANALYSIS,
            new Map<string, string>(
                [
                    ['styles.styleState', 'analysis.styleState'],
                    ['styles.displayStyleState', 'analysis.displayStyleState'],
                    ['styles.color', 'analysis.color'],
                    ['styles.backgroundColor', 'analysis.backgroundColor'],
                    ['styles.fontFamily', 'analysis.fontFamily'],
                    ['styles.fontSize', 'analysis.fontSize'],
                    ['styles.italics', 'analysis.italics'],
                    ['styles.underlined', 'analysis.underlined'],
                    ['styles.bold', 'analysis.bold'],
                    ['styles.alignment', 'analysis.alignment'],
                    ['styles.padding', 'analysis.padding']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.DIVIDER,
            new Map<string, string>(
                [
                    ['styles.styleState', 'divider.styleState'],
                    ['styles.displayStyleState', 'divider.displayStyleState'],
                    ['styles.dividerColor', 'divider.dividerColor'],
                    ['styles.defaultReference', 'divider.defaultReference'],
                    ['styles.height', 'divider.height'],
                    ['styles.marginBottom', 'divider.marginBottom'],
                    ['styles.marginTop', 'divider.marginTop'],
                    ['styles.backgroundColor', 'divider.backgroundColor'],
                    ['styles.padding', 'divider.padding']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.LINK,
            new Map<string, string>(
                [
                    ['styles.styleState', 'link.styleState'],
                    ['styles.displayStyleState', 'link.displayStyleState'],
                    ['styles.color', 'link.color'],
                    ['styles.fontFamily', 'link.fontFamily'],
                    ['styles.fontSize', 'link.fontSize'],
                    ['styles.italics', 'link.italics'],
                    ['styles.underlined', 'link.underlined'],
                    ['styles.bold', 'link.bold'],
                    ['styles.alignment', 'link.alignment'],
                    ['styles.backgroundColor', 'link.backgroundColor'],
                    ['styles.padding', 'link.padding'],
                    ['styles.iconColor', 'link.iconColor'],
                    ['styles.iconSize', 'link.iconSize'],
                    ['styles.iconShape', 'link.iconShape'],
                    ['styles.displayOption', 'link.displayOption'],
                    ['styles.layoutOption', 'link.layoutOption'],
                    ['styles.iconBackgroundColor', 'link.iconBackgroundColor'],
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.CHART,
            new Map<string, string>(
                [
                    ['styles.styleState', 'chart.styleState'],
                    ['styles.displayStyleState', 'chart.displayStyleState'],
                    ['styles.color', 'chart.color'],
                    ['styles.backgroundColor', 'chart.backgroundColor'],
                    ['styles.fontFamily', 'chart.fontFamily'],
                    ['styles.fontSize', 'chart.fontSize'],
                    ['styles.italics', 'chart.italics'],
                    ['styles.underlined', 'chart.underlined'],
                    ['styles.bold', 'chart.bold'],
                    ['styles.alignment', 'chart.alignment'],
                    ['styles.imageAlignment', 'chart.imageAlignment'],
                    ['styles.width', 'chart.width'],
                    ['styles.doBorder', 'chart.doBorder'],
                    ['styles.borderWidth', 'chart.borderWidth'],
                    ['styles.borderColor', 'chart.borderColor'],
                    ['styles.padding', 'chart.padding'],
                    ['styles.accentColor', 'accentColor'],
                    ['styles.cornerRadius', 'chart.cornerRadius']
                ]
            )
        ],
        [
            BriefingBlockTypeEnum.COVERAGE_CURATOR,
            new Map<string, string>(
                [
                    ['styles.styleState', 'curator.styleState'],
                    ['styles.displayStyleState', 'curator.displayStyleState'],
                    ['styles.backgroundColor', 'curator.backgroundColor'],
                    ['styles.padding', 'curator.padding']
                ]
            )
        ],
    ]
);

/**
 * Returns a mapping of properties on the generalStyle object to the related block types and the block type properties
 *
 * @param briefingBlockToGeneralStyle: A mapping of blockTypes to its properties and their related generalStyle properties
 *
 * @returns Map<string, Map<BriefingBlockTypeEnum, string>>
 */
const generalStyleToBriefingBlockHelper = (
    briefingBlockToGeneralStyleProperty: Map<BriefingBlockTypeEnum, Map<string, string>>

): Map<string, Map<BriefingBlockTypeEnum, string>> => {

    const generalStylesToBriefingBlockPropertyMap = new Map<string, Map<BriefingBlockTypeEnum, string>>();

    briefingBlockToGeneralStyle.forEach((generalStylesToBlockPropertyMap, blockType) => {
        generalStylesToBlockPropertyMap.forEach((generalStylesProperty, blockProperty) => {

            // mapping of block type to one of its properties in the context of a generalStylesProperty
            let blockTypeBlockPropertyMap = generalStylesToBriefingBlockPropertyMap.get(generalStylesProperty);

            if (blockTypeBlockPropertyMap) {
                blockTypeBlockPropertyMap.set(blockType, blockProperty);
            } else {
                blockTypeBlockPropertyMap = new Map<BriefingBlockTypeEnum, string>();
                blockTypeBlockPropertyMap.set(blockType, blockProperty);
                generalStylesToBriefingBlockPropertyMap.set(generalStylesProperty, blockTypeBlockPropertyMap);
            }
        });
    });

    return generalStylesToBriefingBlockPropertyMap;
};

/**
 * A mapping of properties on the generalStyle object to the related block types and the block type properties
 */
export const generalStyleToBriefingBlockMap = generalStyleToBriefingBlockHelper(briefingBlockToGeneralStyle);

const getBlockTypeToGeneralStylesTopLevelProperty = (): Map<any, any>[] => {
    const blockTypeToGeneralStylesTopLevelPropertyMap: Map<BriefingBlockTypeEnum, string> = new Map();
    const generalStylesTopLevelPropertyToBriefingBlockTypeMap: Map<string, BriefingBlockTypeEnum> = new Map();

    briefingBlockToGeneralStyle.forEach((blockToGeneralMap, blockType) => {
        const generalStylePropertyString = blockToGeneralMap.values().next().value;
        if (!generalStylePropertyString) {
            return;
        }

        const generalStyleTopLevelProperty = generalStylePropertyString.split('.')[0];

        blockTypeToGeneralStylesTopLevelPropertyMap.set(blockType, generalStyleTopLevelProperty);
        generalStylesTopLevelPropertyToBriefingBlockTypeMap.set(generalStyleTopLevelProperty, blockType);
    });

    return [blockTypeToGeneralStylesTopLevelPropertyMap, generalStylesTopLevelPropertyToBriefingBlockTypeMap];
};

/**
 * A mapping of block types to the specific property on generalStylesModel
 */
export const briefingBlockTypeToGeneralStylesPropertyMap: Map<BriefingBlockTypeEnum, string> = getBlockTypeToGeneralStylesTopLevelProperty()[0];

/**
 * A mapping of generalStylesModels to briefing block types
 */
export const generalStylesPropertyToBriefingBlock: Map<string, BriefingBlockTypeEnum> = getBlockTypeToGeneralStylesTopLevelProperty()[1];
